module.exports = __webpack_public_path__ + "fonts/3107C8_7_0.048832c.woff2";